import { z } from "zod";

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, "Email is required")
    .email("Please enter a valid email address"),
  password: z
    .string()
    .min(8, "Password must be at least 8 characters"),
});

export const registerSchema = z
  .object({
    name: z
      .string()
      .min(1, "Name is required")
      .min(2, "Name must be at least 2 characters"),
    email: z
      .string()
      .min(1, "Email is required")
      .email("Please enter a valid email address"),
    password: z
      .string()
      .min(8, "Password must be at least 8 characters"),
    confirmPassword: z
      .string()
      .min(1, "Please confirm your password"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

export const tradeSchema = z.object({
  currency_pair: z
    .string()
    .min(1, "Currency pair is required")
    .min(3, "Please enter a valid currency pair (e.g. EUR/USD)"),
  risk_amount: z
    .coerce
    .number()
    .min(0.01, "Risk amount must be greater than 0"),
  profit_loss: z
    .coerce
    .number(),
  execution_date: z
    .string()
    .min(1, "Execution date is required"),
  notes: z.string().optional(),
});
